import config from '@/common/appConfig'
import Vue from 'vue'
const vm = new Vue()
import store from '@/store'
import axios from 'axios'
import {
  localGet
} from '@/common/storage.js'
// import {
//   initUserInfo
// } from '@/common/user.js'

/*
 	CODE_OK            = 2000 //成功
	CODE_PARAM_ERR     = 1001 //参数错误
	CODE_SYSTEM_BUSY   = 1002 //系统繁忙
	CODE_SYSTEM_ERR    = 1003 //系统操作失败
	CODE_RELOGIN       = 1004 //请重登
	CODE_ERROR         = 1005 //操作失败(用户toast)    无上报
	CODE_ERROR_NO_HINT = 1006 //操作失败(前后端都不提示)   无上报
	CODE_REFRESH_TOKEN = 1007 //刷新token

	CODE_TOKEN_EXPIRE         = 1201 //token过期（重新取token）
	CODE_TOKEN_NOT            = 1202 //头部无token(上报异常)
	CODE_TOKEN_AND_DEVICE_NOT = 1203 //头部无token并无设备id（重新获取设备id再取token）

	CODE_VIDEO_OFFLINE      = 1300 // 视频下架
	CODE_BALANCE_NOT_ENOUGH = 1301 // 余额不足
  CODE_VIDEO_OFFLINE_COPYRIGHT = 1302 // 因版权原因此剧暂时下架
*/

export default function request({
  method = 'POST',
  url,
  data,
  hostType = 'apiHost'
} = {}) {
  console.log(method, url, data, hostType)
  // const timestamp = new Date().getTime()
  return new Promise((resolve, reject) => {
    let token = store.getters.userInfo.token || localGet('token')
    let header = {
      'App-Version': config.app_version,
      'App-Origin': config.currentApp.pkgGroup,
      'From-App': config.currentApp.pkgName
    }
    axios({
      method,
      url: `${config[hostType]}${url}`,
      headers: {
        'content-type': 'application/json;charset=utf-8',
        'token': token,
        'Phone-Uuid': 'h5_default',
        ...header
      },
      data,
      timeout: 8000
    }).then(res => {
      // if (res.data.STATUS == 1004) {
      //   //   localRemove('token')
      //   //   const appid = config.currentApp.appid
      //   //   const url = config.currentApp.webHost
      //   //   window.top.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
      //   //   url
      //   // )}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
      //   // store.dispatch('')
      // } else
      if (res.data.STATUS != 2000) {
        console.log('22222')
        handleResponseStatus(res)
        reject(res)
      } else {
        console.log('111111')
        resolve(res.data.DATA)
      }
    }).catch(err => {
      // 请求失败弹窗
      vm.$toast.show('服务器错误,请稍后再试', 3000)
      reject(err)
    })
  })
}

// export default function request({
//   method = 'POST',
//   url,
//   data,
//   hostType = 'apiHost'
// } = {}) {
//   const timestamp = new Date().getTime()
//   return new Promise((resolve, reject) => {
//     // 进入initUserInfo 去判断是否需要登录
//     initUserInfo()
//       .then(() =>
//         baseRequest({
//           method,
//           url,
//           data,
//           hostType
//         })
//       )
//       .then((res) => {
//         console.log('initUserInfo', url, (new Date().getTime() - timestamp))

//         console.warn('----接口请求入参---', url)
//         console.log(data)
//         console.warn('---接口返回体---')
//         console.log(res)
//         // token 过期
//         if (res.header && res.header['Token-State'] === 'Expire') {
//           // 强制获取新的token
//           initUserInfo({
//             forced: true
//           })
//         }
//         switch (res.data.STATUS) {
//           case 2000:
//             // 成功
//             resolve(res.data)
//             break
//           case 1001:
//             reject(res)
//             break
//           case 1002:
//             reject(res)
//             break
//           case 1003:
//             reject(res)
//             break
//           case 1300:
//             vm.$toast.show(`视频已下架`,3000)
//             reject(res)
//             break
//           case 1302:
//             vm.$toast.show('因版权原因此剧暂时下架',3000)
//             reject(res)
//             break
//           case 1004:
//             // token过期，且不返回正常数据时，清空当前的token
//             store.commit('user/CLEAR_TOKEN')
//             // 当返回1004时 自动帮用户登录 且重新请求该接口
//             // 强制获取新的token
//             initUserInfo({
//               forced: true
//             })
//               // 重新发起上一个token过期的请求
//               .then(() =>
//                 baseRequest({
//                   method,
//                   url,
//                   data
//                 })
//               )
//               .then((res0) => {
//                 if (res0.data.STATUS === 2000) {
//                   resolve(res0.data)
//                 } else {
//                   handleResponseStatus(res0, url)
//                   reject(res0)
//                 }
//               })
//               .catch((err0) => {
//                 reject(err0)
//               })
//             break
//           case 1005:
//             vm.$toast.show(`${res.data.DESC}`,3000)
//             reject(res)
//             break
//           default:
//             reject(res)
//             break
//         }
//       })
//       .catch((err) => {
//         reject(err)
//       })
//   })
// }

function handleResponseStatus(res) {
  switch (res.data.STATUS) {
    case 1001:
      break
    case 1002:
      break
    case 1003:
      break
    case 1300:
      vm.$toast.show(`视频已下架`, 3000)
      break
    case 1302:
      vm.$toast.show(`因版权原因此剧暂时下架`, 3000)
      break
    case 1004:
      break
    case 1005:
      vm.$toast.show(`${res.data.DESC}`, 3000)
      break
    default:
      break
  }
}
